import * as React from 'react';
var useFocus = function () {
    var htmlElRef = React.useRef(null);
    var setFocus = React.useCallback(function () {
        var _a;
        (_a = htmlElRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return [htmlElRef, setFocus];
};
export default useFocus;
//# sourceMappingURL=useFocus.js.map